import React, { useState, useEffect } from "react";
import { getDatabase, ref, onValue, set, remove } from "firebase/database";
import app from "../firebase";

const AdminMessagesPage = () => {
  const db = getDatabase(app);
  const [editedMessage, setEditedMessage] = useState({
    message: "",
    title: "",
    isActive: false,
  });
  const [loading, setLoading] = useState(true);
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    const fetchMessage = () => {
      try {
        setLoading(true);
        const messageRef = ref(db, "messages");
        onValue(messageRef, (snapshot) => {
          const data = snapshot.val();
          if (data) {
            setEditedMessage(data);
          } else {
            setEditedMessage({ message: "", title: "", isActive: false });
          }
          setLoading(false);
        });
      } catch (error) {
        console.error("Error fetching message: ", error);
        setAlertMessage("Failed to fetch message. Please try again.");
        setLoading(false);
      }
    };

    fetchMessage();
  }, [db]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedMessage((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setLoading(true);
    setAlertMessage("");
    try {
      const messageRef = ref(db, "messages");
      await set(messageRef, editedMessage);
      setAlertMessage("Message updated successfully!");
    } catch (error) {
      console.error("Error updating message: ", error);
      setAlertMessage("Failed to update message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    setAlertMessage("");
    try {
      const messageRef = ref(db, "messages");
      await remove(messageRef);
      setEditedMessage({ message: "", title: "", isActive: false });
      setAlertMessage("Message deleted successfully!");
    } catch (error) {
      console.error("Error deleting message: ", error);
      setAlertMessage("Failed to delete message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <p className="text-lg text-gray-600">Loading message...</p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-lg mt-8">
      <h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">
        Admin Messages
      </h1>
      {alertMessage && (
        <div
          className={`p-4 mb-6 rounded-md text-sm ${
            alertMessage.includes("successfully")
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {alertMessage}
        </div>
      )}
      <div className="space-y-6">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 items-center">
          <label className="text-sm font-medium text-gray-700">Title</label>
          <input
            type="text"
            name="title"
            value={editedMessage.title}
            onChange={handleInputChange}
            className="col-span-2 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter title"
          />
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 items-start">
          <label className="text-sm font-medium text-gray-700">Message</label>
          <textarea
            name="message"
            value={editedMessage.message}
            onChange={handleInputChange}
            className="col-span-2 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y"
            rows="4"
            placeholder="Enter message"
          />
        </div>
        <div className="flex justify-end space-x-4">
          <button
            onClick={handleSave}
            disabled={loading}
            className={`px-6 py-2 rounded-md text-white ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            } transition duration-200`}
          >
            {loading ? "Saving..." : "Save"}
          </button>
          <button
            onClick={handleDelete}
            disabled={loading}
            className={`px-6 py-2 rounded-md text-white ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-red-500 hover:bg-red-600"
            } transition duration-200`}
          >
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminMessagesPage;
